import { placeholderImage } from "./placeholder-image.js";
import { isPresent } from "./type-guards.js";
const FRONT_IMAGE = "Front";
function getFrontImage(images) {
  if (!isPresent(images) || !images.length) {
    return placeholderImage;
  }
  const frontImage = images.find((image) => image.label === FRONT_IMAGE);
  return frontImage ?? images[0] ?? placeholderImage;
}
export {
  getFrontImage as default
};
//# sourceMappingURL=get-front-image.js.map
